import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import moment from 'moment';

import ButtonLink from '../global/button-link';
import Section from '../global/section';

const EventsStyle = styled.div`
	section {
		background-image: url(${(p) => p.bimg});
		background-size: 50%;
		background-position: -10% 50px;
		background-repeat: no-repeat;
	}
	h2 {
		font-size: 2.5rem;
		margin-bottom: 4rem;
		padding: 0 1rem;
		span {
			color: ${(p) => p.theme.color.green};
		}
	}
	.flex {
		padding: 0 1rem;
		display: flex;
		.img-wrap {
			width: 30%;

			img {
				width: 100%;
				border: 4px solid white;
				z-index: 10;
				box-shadow: 0 0 16px 8px rgba(0, 0, 0, 0.25);
			}
		}
		.content-wrap {
			width: 70%;
			margin: 2rem 0;
			padding: 3rem;
			background-color: ${(p) => p.theme.color.purple};
			border-radius: 0 20px 20px 0;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			z-index: 5;

			h3 {
				font-size: 2rem;
				margin-bottom: 2rem;
			}
			h4 {
				font-size: 1.4rem;
				font-weight: 700;
				margin-bottom: 3rem;
				line-height: 1.2;
			}
			p {
				font-size: 1.125rem;
				margin-bottom: 1rem;
			}
			span {
				color: ${(p) => p.theme.color.green};
			}
		}
		.button-tray {
			a {
				margin-top: 1rem;
				&:first-child {
					margin-right: 2rem;
				}
			}
		}
		@media all and (max-width: 1050px) {
			background-color: ${(p) => p.theme.color.purple};
			border-radius: 20px;
		}
	}
	@media all and (max-width: 850px) {
		h2 {
			margin-bottom: 5rem;
		}
		.flex {
			flex-direction: column;
			.img-wrap {
				max-width: 300px;
				width: 100%;
				padding: 0 3rem;
				margin-top: -3rem;
				margin-right: auto;
				margin-left: auto;
			}
			.content-wrap {
				width: 100%;
				margin-top: 0;
				padding-top: 2rem;
			}
		}
	}
	@media all and (max-width: 550px) {
		.flex {
			.img-wrap {
				padding: 0;
			}
			.content-wrap {
				padding: 2rem 0 0;
				h3 {
					margin-bottom: 1.5rem;
				}
				h4 {
					margin: 1rem 0 1.5rem;
				}
			}
		}
	}
`;

export default ({ title, color, event }) => {
	return (
		<EventsStyle
			bimg={color === 'dark' ? '/img/Purple_Blob.svg' : '/img/Green_Blob.svg'}
		>
			<Section bg={color}>
				<h2>
					<span>></span> {title}
				</h2>
				{event ? (
					<div className="flex">
						<div className="img-wrap">
							<Link to={event.fields.slug}>
								<img src={event.poster} alt={event.title} />
							</Link>
						</div>
						<div className="content-wrap">
							<div>
								<h3>
									<span>></span> {event.title}
								</h3>
								<p>{event.excerpt}</p>
							</div>
							<div>
								<h4>
									{event.location} |{' '}
									<span>{moment(event.date).format('MMM DD, YYYY')}</span>
								</h4>
								<div className="button-tray">
									<ButtonLink to={event.fields.slug} bg="teal">
										VIEW EVENT
									</ButtonLink>
									{color === 'dark' && (
										<ButtonLink to="/contact/?interest=host#form" bg="teal">
											HOST AN EVENT
										</ButtonLink>
									)}
								</div>
							</div>
						</div>
					</div>
				) : (
					<h3>
						There are currently no featured events. <br />
						Check back soon for updates!
					</h3>
				)}
			</Section>
		</EventsStyle>
	);
};
